














































































































import { Vue, Component } from "vue-property-decorator";
import Sidebar from "@/modules/businesses/components/Sidebar.vue";
import UBOTable from "@/modules/businesses/components/UBOTable.vue";
import StatusBanner from "@/modules/businesses/components/StatusBanner.vue";
import { namespace } from "vuex-class";
import { Status } from "@/modules/businesses/types/index";
import {
  Business,
  ToggleCompanyStatusPayload,
} from "@/modules/businesses/types";
import { AxiosResponse } from "node_modules/axios";

const BusinessNamespace = namespace("business");

@Component({
  components: {
    sidebar: Sidebar,
    "ubo-table": UBOTable,
    "status-banner": StatusBanner,
  },
})
export default class BusinessPage extends Vue {
  @BusinessNamespace.Getter("getCurrentBusiness") currentBusiness: Business;
  @BusinessNamespace.Action("fetchCurrentBusiness")
  fetchCurrentBusiness!: (companyId: string) => Promise<{}>;

  isPending: Status = Status.PENDING;
  isApproved: Status = Status.APPROVED;
  isRejected: Status = Status.REJECTED;

  async mounted() {
    const businessId = this.$route.params.businessId;
    await this.fetchCurrentBusiness(businessId).catch((err) => {
      console.log(err.message);
    });
  }
}
